import React from 'react';

const getStatusColor = (status) => {
  if (!status) return 'text-gray-500';
  
  switch (status.toLowerCase()) {
    case 'extreme fear':
      return 'text-purple-600';
    case 'fear':
      return 'text-indigo-600';
    case 'greed':
      return 'text-yellow-500';
    case 'extreme greed':
      return 'text-red-500';
    default:
      return 'text-gray-500';
  }
};

const FearAndGreedIndicator = ({ score, status }) => {
  return (
    <div className="flex items-center whitespace-nowrap">
      <span className="mr-1 font-medium lg:hidden">F&G:</span>
      <span className="mr-2 font-medium hidden lg:inline">Fear&nbsp;&&nbsp;Greed:</span>
      <a 
        href="https://alternative.me/crypto/fear-and-greed-index/"
        target="_blank"
        rel="noopener noreferrer"
        className={`${getStatusColor(status)}`}
      >
        <span className={`font-bold ${getStatusColor(status)} mr-1`}>
          {score || 'N/A'}
        </span>
        <span className={`hidden lg:inline text-xs ${getStatusColor(status)}`}>
          ({status || 'Unknown'})
        </span>
      </a>
    </div>
  );
};

export default FearAndGreedIndicator; 